export default __webpack_public_path__ + "static/media/chevron-left.297aeb3c.svg";